<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width=24
    :height=24
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_1165_334)">
      <path d="M20 2H4C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2Z" fill="#D5D8DC"/>
      <path d="M7.91927 10.25H7.33594C6.69161 10.25 6.16927 10.7723 6.16927 11.4167V15.5C6.16927 16.1443 6.69161 16.6667 7.33594 16.6667H7.91927C8.5636 16.6667 9.08594 16.1443 9.08594 15.5V11.4167C9.08594 10.7723 8.5636 10.25 7.91927 10.25Z" fill="#363C43"/>
      <path d="M14.263 17.25H12.4163C11.9556 17.25 11.5053 17.1136 11.122 16.8581L10.2196 16.2565C10.0573 16.1483 9.95981 15.9662 9.95981 15.7711V10.9882C9.95981 10.8867 9.9863 10.787 10.0367 10.6988L12.2931 6.75H12.9625C14.088 6.75 14.7893 7.97094 14.2221 8.94314L13.4598 10.25H16.3406C17.0996 10.25 17.6565 10.9633 17.4724 11.6996L16.5267 15.4826C16.267 16.5213 15.3337 17.25 14.263 17.25Z" fill="#3CB149"/>
    </g>
    <defs>
      <clipPath id="clip0_1165_334">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>


</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
